import { useCallback, useEffect, useState } from "react";
import { usePagination } from "../../../hooks/usePagination";
import { format } from "date-fns";
import RightIcon from "../../svg/RightIcon";
import LeftIcon from "../../svg/LeftButton";
import { Card } from "reactstrap";
import Table from "../../table/Table";
import LoadingComponent from "../../lodingComponent";
import FilterIcon from "../../svg/FilterIcon";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import { Filter } from "react-feather";
import DownloadExcel from "../../downloadExcel/DownloadExcel";
import ApiService from "../../../services/apiService";
import { method } from "lodash";
import { toast } from "react-toastify";



const DMSList = () =>{
     

    const [excelData,setExcelData] = useState<any[]>([])

    let reformedData:any = []
    let updatedData: any = [];
    const role = useAppSelector((state) => state.role.role);
    const {
        data,
        pageNumber,
        setPageNumber,
        pageSize,
        totalCount,
        setRefresh,
        setSearchQuery,
        searchQuery,
        filterOn,
        setSortBy,
        loading,
      } = usePagination({
        endpoint: `/chack/getchildchak`,
        filterOn: "ChackName",
        enabled: true,
      });
      const totalPages = Math.ceil(totalCount / pageSize);

      const handleNext = useCallback(() => {
        setPageNumber((prev) => Math.min(totalPages, prev + 1));
      }, [setPageNumber, totalPages]);
    
      const handlePrev = useCallback(() => {
        setPageNumber((prev) => Math.max(1, prev - 1));
      }, [setPageNumber, totalPages]);
    
      if (data) {
        updatedData = data.map((time) => {
          const formatDate = format(new Date(time.dateTime), "yyyy-MM-dd HH:mm:ss");
          return {
            ...time,
            dateTime: formatDate,
          };
        });
      }
    
    const getChildChakForExcel = async() =>{
       try{
       const res = await ApiService.axiosApi(`/chack/getchildchak`,{
            method:'GET',
            params :{
              pageNumber:0,
              pageSize:0
            }
       })
       if(res.success){
          setExcelData(res.data.data)
       }else{
          toast.error('unable to download excel')
       }
      }catch(e){
         console.error("dms list :",e)
      }
    }

     useEffect(()=>{
         getChildChakForExcel();
     },[])

    if (Array.isArray(excelData) && excelData.length > 0) {
      reformedData = excelData.map((time) => {
        const formatDate = format(new Date(time.dateTime), "yyyy-MM-dd HH:mm:ss");
        return {
          ...time,
          dateTime: formatDate,
        };
      });
    }
 
     
  return(

      <>
           <Breadcrumbs mainTitle={"Dms"} parent={"Lists"} />

<Card>
  <CommonCardHeader title="Dms List" headClass="pb-3" />
  <div className="d-flex justify-content-between pb-2">
    <div
      style={{ marginLeft: "10px" }}
      className="align-items-center  flex-row d-flex"
    >

      <div>
        <input
          type="text"
          className="search-input"
          placeholder="...search"
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setPageNumber(1);
          }}
        />
      </div>
      <div>
        <button
          className="filter-button mx-2 p-1"
          style={{ height: "30px" }}
          onClick={() => setSortBy("ChackName")}
        >
          <Filter />
        </button>
      </div>
  
      
    </div>
  
      <div className="d-flex justify-content-end p-r-10">
        <div>
      <DownloadExcel
                  data={reformedData}
                  ExcelSheetName="Dms List"
                  
                  hideColumns={["id", 

                     "chakId",
                     "distributaryZoneId",
                     "pressure",
                     "flowRate",
                     "todayVolume",
                     "onValves",
                     "door1",
                     "door2",
                     "waterMeter",
                     "romsAuto",
                     "long",
                     "lat",
                     "v1",
                     "v2",
                     "v3",
                     "v4",
                     "v5",
                     "v6",
                     "v7",
                     "v8",
                     "v9",
                     "v10",
                     "v11",
                     "v12",
                     "v13",
                     "v14",
                     "wua_Id",
                     "deviceType",
                     "fwVersion",
                     "pcfrV_ScadaControl",
                     "schemeVillageId",
                     "no_Of_ON_OF_Valves",
                     "inletPressure2",
                     "chackLeader",
                     "chackLeader_MobileNumber",
                     "chackArea",
                     "pfcmd1_outpt",
                     "pfcmd1_position",
                     "pfcmd1_flow",
                     "pfcmd1_dailyvolume",
                     "pfcmd1_runtime",
                     "pfcmd2_outpt",
                     "pfcmd2_position",
                     "pfcmd2_flow",
                     "pfcmd2_dailyvolume",
                     "pfcmd2_runtime",
                     "pfcmd3_outpt",
                     "pfcmd3_position",
                     "pfcmd3_flow",
                     "pfcmd3_dailyvolume",
                     "pfcmd3_runtime",
                     "pfcmd4_outpt",
                     "pfcmd4_position",
                     "pfcmd4_flow",
                     "pfcmd4_dailyvolume",
                     "pfcmd4_runtime",
                     "pfcmd1_modedata",
                     "pfcmd1_mode_manualbit",
                     "pfcmd1_mode_autobit",
                     "pfcmd1_mode_positionbit",
                     "pfcmd1_mode_flowbit",
                     "pfcmd1_mode_open_close",
                     "pfcmd1_mode_testbit",
                     "pfcmd2_modedata",
                     "pfcmd2_mode_manualbit",
                     "pfcmd2_mode_autobit",
                     "pfcmd2_mode_positionbit",
                     "pfcmd2_mode_flowbit",
                     "pfcmd2_mode_open_close",
                     "pfcmd2_mode_testbit",
                     "pfcmd3_modedata",
                     "pfcmd3_mode_manualbit",
                     "pfcmd3_mode_autobit",
                     "pfcmd3_mode_positionbit",
                     "pfcmd3_mode_flowbit",
                     "pfcmd3_mode_open_close",
                     "pfcmd3_mode_testbit",
                     "pfcmd4_modedata",
                     "pfcmd4_mode_manualbit",
                     "pfcmd4_mode_autobit",
                     "pfcmd4_mode_positionbit",
                     "pfcmd4_mode_flowbit",
                     "pfcmd4_mode_open_close",
                     "pfcmd4_mode_testbit",
                     "pfcmdType",
                     "valveOpen",
                     "valveClosed",
                     "stopIrrigation",
                     "rssi",
                     "snr",
                     "sustainingPressurePfcmd1",
                     "reducingPressurePfcmd1",
                      "sustainingPressurePfcmd2",
                     "reducingPressurePfcmd2",
                        "sustainingPressurePfcmd3",
                     "reducingPressurePfcmd3",
                        "sustainingPressurePfcmd4",
                     "reducingPressurePfcmd4"

                  ]}
                  order={["headQuaterName","chackName","duid"]}
                  skipColumnsCount={1}
                />
      </div>
      </div>

  </div>
  {loading ? (
    <LoadingComponent />
  ) : (
    <Table
      isAction={false}
      data={updatedData}
      columns={[
        {header:'Wua',accessor:'headQuaterName'},
        { header: "Chak Name", accessor: "chackName" },
       
        { header: "Distrbutary/Zone", accessor: "distributary_Zone" },
        { header: "Scheme/Village", accessor: "scheme_Village" },
        { header: "Duty", accessor: "duty" },
        { header: "Updated Time", accessor: "dateTime" },
        
       
        { header: "On Valves", accessor: "onValves" },
        { header: "Door1", accessor: "door1" },
        
        { header: "Network Status", accessor: "networkStatus" },
      
        { header: "Solar Voltage(V)", accessor: "solarVoltage" },
        { header: "Temperature(°C)", accessor: "temprature" },
       
        { header: "Dms Auto", accessor: "romsAuto" },
      ]}
      buttons={[]}
    />
  )}

  <div
    className=" d-flex justify-content-end align-content-center"
    style={{ marginRight: "10px", marginTop: "10px" }}
  >
    <p style={{ marginRight: "10px", marginTop: "8px" }}>
      Page {pageNumber} of {totalPages}
    </p>
    <button
      onClick={handlePrev}
      disabled={pageNumber === 1}
      className={`icon-button ${
        pageNumber === totalPages ? "disabled" : ""
      }`}
    >
      <LeftIcon className="icon" />
    </button>
    <button
      className={`icon-button ${
        pageNumber === totalPages ? "disabled" : ""
      }`}
      onClick={handleNext}
      disabled={pageNumber === totalPages}
    >
      <RightIcon className="icon" />
    </button>
  </div>
</Card>

      </>
  )

}

export default DMSList